import ContactView from './scenes/View';

export { ContactView };
export {default} from './ContactRouter';
